import { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useSelector } from 'react-redux';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';

export const DeleteButtonAbm = ({ permiso, handleDelete, mensajeEliminacion, children }) => {
  const { permisos: permisosUser } = useSelector(state => state.auth)
  const [openDelete, setOpenDelete] = useState(false)

  const handleClickOpenDelete = () => {
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleContinuarDelete = () => {
    handleDelete()
    handleCloseDelete()
  }

  return (
    <>
      {
        (permiso === null || validarSoloUnPermiso(permisosUser, permiso)) &&
        <>
          <IconButton
            aria-label="Eliminar"
            onClick={handleClickOpenDelete}
          >
            <DeleteForeverIcon sx={{ fontSize: "2rem" }} />
          </IconButton>
          {
            openDelete &&
            <Dialog
              fullWidth
              maxWidth="sm"
              open={openDelete}
              onClose={handleCloseDelete}
            >
              <DialogTitle>Eliminar</DialogTitle>
              <DialogContent>
                <DialogContentText style={{ textAlign: "center", fontSize: "1.5em", fontWeight: "lighter" }}>
                  {mensajeEliminacion || "¿Estás seguro que deseas eliminar este item?"}
                </DialogContentText>
                {children}
              </DialogContent>
              <DialogActions>
                <Button color='secondary' onClick={handleCloseDelete}>Cancelar</Button>
                <Button color="primary" variant="contained" onClick={handleContinuarDelete}>Continuar</Button>
              </DialogActions>
            </Dialog>
          }
        </>
      }
    </>
  )
}